function selectedCarSeatBrands(state={}, action) {
  switch(action.type) {
    case "CHANGE_SELECTED_CAR_SEAT_BRAND" :
      let new_state = {...state, };
      new_state[action.key] = action.value;
      return new_state;
    default :
      return state;
  }
}

export default selectedCarSeatBrands;



/** WEBPACK FOOTER **
 ** ./src/reducers/selectedCarSeatBrands.js
 **/